import { render } from "./CentralDoAluno.vue?vue&type=template&id=22daa870&scoped=true"
import script from "./CentralDoAluno.vue?vue&type=script&lang=js"
export * from "./CentralDoAluno.vue?vue&type=script&lang=js"

import "./CentralDoAluno.vue?vue&type=style&index=0&id=22daa870&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22daa870"]])

export default __exports__